import styled from "@emotion/styled";
import Button from "../../UI/Button";
import theme from "../../UI/theme";
import { WeekType } from "./Content/modal";

export const FooterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    padding: 1rem 0;
`;

export const CustomButton = styled(Button)`
    width: 30%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${theme.colors.primary};
    color: #fff;
    height: 40px;
    border-radius: 12px;
    transition: 0.2s ease all;
    &:hover {
        transform: scale(1.1);
    }
`;

export const CheckboxWrapper = styled.div`
    & input#isOddWeekUsed {
        margin-right: 0.5rem;
        box-shadow: none;
        cursor: pointer;
    }
    & label {
        cursor: pointer;
    }
`;

export const HeaderButton = styled.div<{ active: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 25%;
    height: 30px;
    padding-top: 2px;
    border: 1px solid ${theme.colors.lightGray};
    border-radius: 15px;
    cursor: pointer;
    color: ${(props) => (props.active ? "white" : "unset")};
    background-color: ${(props) =>
        props.active ? theme.colors.primary : "unset"};
`;

export const HeaderButtonsWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-evenly;
`;

export const HeaderText = styled.h3`
    margin: 2rem auto;
    font-size: 1.25rem;
    text-transform: uppercase;
`;

export const HeaderMainWrapper = styled.div`
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const confirmationContent = styled.div`
    padding: 12rem;
    display: flex;
    justify-content: center;
`;

export const WeekTypeHeader = styled.h5<{ weekType: WeekType }>`
    font-size: 1.25rem;
    font-weight: ${theme.typography.fontWeight.normal};
    margin: ${(props) =>
        props.weekType === "odd" ? " 1.75rem 1rem 0" : "0 1rem 0"};
    text-align: center;
`;

export const IndividualWeekSettingsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;
